var _g, _path, _path2, _path3, _path4, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFreePlan(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 98,
    height: 98,
    viewBox: "0 0 98 98",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1_208)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 49,
    cy: 45,
    r: 39,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 49,
    cy: 45,
    r: 38.5,
    stroke: "#5B73E8"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M51.9981 45.6687L53.6711 44.0377L51.3596 43.7022C50.9706 43.6463 50.635 43.4016 50.4615 43.0497L49.4269 40.9548L48.3923 43.0496C48.2187 43.4014 47.8832 43.6461 47.4941 43.7021L45.1826 44.0376L46.8556 45.6686C47.1364 45.9424 47.2646 46.3374 47.1982 46.7241L46.8044 49.0274L48.8712 47.9404C49.0459 47.8483 49.2359 47.8029 49.4269 47.8029C49.6179 47.8029 49.8079 47.8482 49.9826 47.9404L52.0493 49.0274L51.6555 46.7241C51.5891 46.3374 51.7172 45.9425 51.9981 45.6687Z",
    fill: "#27B783"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M49.4258 32.2955C42.1897 32.2955 36.3027 38.1825 36.3027 45.4186C36.3027 52.6547 42.1897 58.5417 49.4258 58.5417C56.6619 58.5417 62.5489 52.6547 62.5489 45.4186C62.5489 38.1825 56.6618 32.2955 49.4258 32.2955ZM57.0661 44.0601L54.1116 46.9413L54.8083 51.0086C54.8852 51.4559 54.7011 51.908 54.3341 52.1759C53.9633 52.443 53.4781 52.4768 53.077 52.2657L49.4258 50.3456L45.7745 52.2656C45.375 52.4799 44.888 52.4415 44.5174 52.1759C44.1504 51.9079 43.9663 51.4559 44.0433 51.0085L44.74 46.9412L41.7854 44.0601C41.4604 43.7432 41.3439 43.269 41.4837 42.8367C41.6246 42.4056 41.9975 42.0911 42.4472 42.0258L46.5295 41.4329L48.3564 37.7327C48.7572 36.9171 50.0946 36.9171 50.4954 37.7327L52.3223 41.4329L56.4046 42.0258C56.8543 42.091 57.2272 42.4056 57.3681 42.8367C57.5077 43.2691 57.3912 43.7432 57.0661 44.0601Z",
    fill: "#27B783"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M69.6965 32.5528C69.5125 32.1067 69.0767 31.8165 68.5944 31.8165H63.0383V26.2604C63.0383 25.7782 62.7482 25.3424 62.302 25.1583C61.8581 24.9719 61.342 25.0744 61.0018 25.417L55.3389 31.0799C59.1509 32.6547 62.2001 35.704 63.7749 39.516L69.4378 33.8531C69.7792 33.5117 69.8817 32.9992 69.6965 32.5528Z",
    fill: "#27B783"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M35.0753 51.3167L29.4123 56.9796C29.0709 57.321 28.9684 57.8336 29.1536 58.2799C29.3376 58.726 29.7734 59.0162 30.2557 59.0162H35.8229V64.5722C35.8229 65.0545 36.102 65.4903 36.5482 65.6744C36.9882 65.8578 37.504 65.7601 37.8484 65.4157L43.5114 59.7527C39.6993 58.1779 36.6502 55.1287 35.0753 51.3167Z",
    fill: "#27B783"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1_208",
    x: 0,
    y: 0,
    width: 98,
    height: 98,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1_208"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1_208",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFreePlan);
export default __webpack_public_path__ + "static/media/freePlan.530e42bab9bc83ffbcaa501666d11515.svg";
export { ForwardRef as ReactComponent };